import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './views/theme/base/base.component';
import { CallbackComponent } from './callback/callback.component';
import { RedirectGuard } from './core/_config/redirect-guard';
import { NlogComponent } from './views/pages/nlog/nlog.component';
import { PixResultsComponent } from './views/pages/pix-results/pix-results.component';
import { AutomaticDebitComponent } from './views/pages/automatic-debit/rem/automatic-debit.component';
import { AutomaticDebitImportComponent } from './views/pages/automatic-debit/ret/automatic-debit-import/automatic-debit-import.component';
import { AutomaticDebitSelecFileComponent } from './views/pages/automatic-debit/ret/automatic-debit-selec-file/automatic-debit-selec-file.component';
import { AutomaticDebitRetTableComponent } from './views/pages/automatic-debit/ret/automatic-debit-ret-table/automatic-debit-ret-table.component';
import { ManageAgreementComponent } from './views/pages/agreement-external-collector/manage-agreement/manage-agreement.component';
import { AgreementDetailComponent } from './views/pages/agreement-external-collector/agreement-detail/agreement-detail.component';
import { CreateAgreementComponent } from './views/pages/agreement-external-collector/create-agreement/create-agreement.component';

const routes: Routes = [
    {
        path: '',
        component: BaseComponent,
        children: [
            {
                path: 'home',
                loadChildren: () => import('./views/pages/home/home.module').then((m) => m.DashboardModule),
            },
            {
                path: 'mail',
                loadChildren: () => import('./views/pages/apps/mail/mail.module').then((m) => m.MailModule),
            },
            {
                path: 'fileReturn',
                loadChildren: () =>
                    import('./views/pages/fileReturn/fileReturn.module').then((m) => m.FileReturnModule),
            },
            {
                path: 'fileRemitance',
                loadChildren: () =>
                    import('./views/pages/file-remitance/file-remitance.module').then((m) => m.FileRemitanceModule),
            },
            {
                path: 'collector-file',
                loadChildren: () =>
                    import('./views/pages/collector-file/collector-file.module').then((m) => m.CollectorFileModule),
            },
            {
                path: 'recurring-card',
                loadChildren: () =>
                    import('./views/pages/recurring-card/recurring-card.module').then((m) => m.RecurringCardModule),
            },
            {
                path: 'tasks',
                loadChildren: () => import('./views/pages/tasks/tasks.module').then((m) => m.TasksModule),
            },
            {
                path: 'bugs',
                loadChildren: () => import('./views/pages/bugs/bugs.module').then((m) => m.BugsModule),
            },
            {
                path: 'manager',
                loadChildren: () => import('./views/pages/manager/manager.module').then((m) => m.ManagerModule),
            },
            {
                path: 'accounting',
                loadChildren: () =>
                    import('./views/pages/accounting/accounting.module').then((m) => m.AccountingModule),
            },
            {
                path: 'cashier',
                loadChildren: () => import('./views/pages/cashier/cashier.module').then((m) => m.CashierModule),
            },
            {
                path: 'billet',
                loadChildren: () => import('./views/pages/billet/billet.module').then((m) => m.BilletModule),
            },
            { path: 'nlog', component: NlogComponent },
            { path: 'receiving/pix-results', component: PixResultsComponent },
            { path: 'callback', component: CallbackComponent },

            {
                path: 'Afs',
                canActivate: [RedirectGuard],
                component: RedirectGuard,
            },
            { path: 'automatic-debit/rem', component: AutomaticDebitComponent },
            { path: 'automatic-debit/ret', component: AutomaticDebitRetTableComponent },
            { path: 'automatic-debit/ret/import', component: AutomaticDebitImportComponent },
            { path: 'automatic-debit/ret/select-file', component: AutomaticDebitSelecFileComponent },
            { path: 'agreement-external-collector/manage-agreement', component: ManageAgreementComponent },
            { path: 'agreement-external-collector/agreement-detail', component: AgreementDetailComponent },
            { path: 'agreement-external-collector/new', component: CreateAgreementComponent },
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: '**', redirectTo: 'home', pathMatch: 'full' },
        ],
    },
    { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];

@NgModule({
    imports: [CommonModule, RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
    constructor(private router: Router) {
        let urlModifySplit: any, urlModifySplice: any, urlEnd: any;

        let url = window.location.href;

        urlModifySplit = url.split('/');

        urlModifySplice = urlModifySplit.splice(3, 3, Number.MAX_VALUE);
        let isCallback: boolean = !(urlModifySplice[0].indexOf('callback') === -1);

        if (!isCallback) {
            urlEnd = urlModifySplice.join('/');
            if (urlEnd) {
                urlEnd = `/${urlEnd}`;
            } else {
                urlEnd = `dashboard`;
            }

            let urlPath = urlEnd.split('?')[0];
            sessionStorage.setItem('urlStart', urlPath);

            let urlParams = new URL(window.location.href).searchParams;

            this.setContext(urlParams);
        }
    }

    setContext(urlParams: URLSearchParams) {
        let contextSelectString = urlParams.get('ContextSelected');
        if (contextSelectString) {
            let uriDecode = decodeURI(contextSelectString);

            let contextSelected = JSON.parse(uriDecode);

            sessionStorage.setItem('ContextSelected', JSON.stringify(contextSelected));
        }
    }
}
